<div class="cx-order-items container" *ngIf="order$ | async as order">
  <!-- TODO: (CXSPA-6313) - Remove feature flag next major release -->
  <h3
    *cxFeature="'a11yOrderConfirmationHeadingOrder'"
    class="cx-order-items-header"
  >
    {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
  </h3>
  <h4
    *cxFeature="'!a11yOrderConfirmationHeadingOrder'"
    class="cx-order-items-header"
  >
    {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
  </h4>

  <cx-promotions
    [promotions]="order.appliedOrderPromotions || []"
  ></cx-promotions>

  <cx-cart-details
    [customCart]="order"
    [showPromotions]="false"
  />
</div>
